export default __webpack_public_path__ + "static/media/Shadow's Leggings of the Final Way.88eeb55c.jpg";